import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAdminSwimmers, updateSwimmerPayment } from '../../api/admin';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';

const SwimmersAdminPanel = () => {
    const [swimmers, setSwimmers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const { logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSwimmers = async () => {
            try {
                setLoading(true);
                const response = await getAdminSwimmers(searchTerm);
                console.log('API Response:', response.data); // Добавьте эту строку
                setSwimmers(response.data);
            } catch (error) {
                console.error('Error:', error);
                if (error.response?.status === 401) {
                    toast.error('Требуется авторизация');
                    logout();
                    navigate('/loginsw');
                } else {
                    toast.error('Ошибка загрузки данных');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchSwimmers();
    }, [searchTerm, logout, navigate]);

    const handlePaymentUpdate = async (swimmerId, field, value) => {
        try {
            const swimmer = swimmers.find(s => s.id === swimmerId);
            const updatedData = {
                ...swimmer,
                [field]: parseFloat(value) || 0
            };

            await updateSwimmerPayment(swimmerId, updatedData);

            setSwimmers(swimmers.map(s =>
                s.id === swimmerId ? { ...s, [field]: parseFloat(value) || 0 } : s
            ));

            toast.success('Данные обновлены');
        } catch (error) {
            toast.error('Ошибка обновления');
        }
    };

    const getPaymentStatusClass = (swimmer) => {
        if (swimmer.payment_debt >= swimmer.total_amount && swimmer.payment_debt > 0 || swimmer.total_amount == 0) {
            return 'bg-green-50 border-l-4 border-green-500';
        }
        if (swimmer.total_amount > 0) {
            return 'bg-yellow-50 border-l-4 border-yellow-500';
        }
        return 'bg-red-50 border-l-4 border-red-500';
    };

    return (
        <div className="registration-container" style={{width: 100 + '%',maxWidth: 1200 + 'px'}}>
        <div className="container mx-auto px-4 py-8">
            <div className="mb-6 flex justify-between items-center">
                <h1 className="text-2xl font-bold">Администрирование регистраций</h1>
                <button
                    onClick={logout}
                    className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                >
                    Выйти
                </button>
            </div>

            <div className="mb-6">
                <input
                    type="text"
                    placeholder="Поиск по имени, фамилии или email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="form-input w-full px-4 py-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
            </div>

            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                </div>
            ) : (
                <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">№ участника</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ФИО</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Дистанции</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Стоимость</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Оплачено</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Статус</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {swimmers.map((swimmer) => (
                            <tr key={swimmer.id} className={getPaymentStatusClass(swimmer)} style={{borderBottom: 1 + "px solid #ebebeb"}}>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-900">
                                        {swimmer.id}
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-900">
                                        {swimmer.first_name} {swimmer.last_name}
                                    </div>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="text-sm text-gray-900">
                                        {swimmer.distances.map(d => `${d.meters}m ${d.style}`).join(', ')}
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {swimmer.total_amount} руб.
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <input
                                        type="number"
                                        value={swimmer.payment_debt}
                                        onChange={(e) => handlePaymentUpdate(swimmer.id, 'payment_debt', e.target.value)}
                                        className="form-input w-24 px-2 py-1 border rounded focus:ring-blue-500 focus:border-blue-500"
                                        min="0"
                                        step="0.01"
                                    />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {swimmer.payment_debt >= swimmer.total_amount && swimmer.payment_debt > 0 || swimmer.payment_debt == swimmer.total_amount ? (
                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        Оплачено
                      </span>
                                    ) : swimmer.payment_debt > 0 ? (
                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                        Частично
                      </span>
                                    ) : (
                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                        Не оплачено
                      </span>
                                    )}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
        </div>
    );
};

export default SwimmersAdminPanel;
